<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.clientInfo}}</h4>
            <div v-if="(formName == 'organisation' && disabledButton) || (formName == 'client' && countries == null)">
                <Loading/>
            </div>
            <form  class="text-left" v-if="countries != null">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div :class="{'disabledInput': $route.path.includes('update') || noClient}" class="px-4"
                     style="margin-left: -4.5%"
                     v-if="formName == 'organisation' ">
                    <div class="row">
                        <div class="col-lg-12">
                            <DropDownVue :icon="icons.user"
                                         :items="clients"
                                         :label="titles.choiceClient"
                                         :validate="$v.formComponent.organisation.client.id"
                                         @method="handleChangeDropDown"
                                         inputKey="client"
                                         itemKey="id"
                                         itemValue="email"
                            />
                        </div>
                    </div>
                </div>
                <div class="px-4" style="margin-left: -4.5%"
                     v-if="formName == 'organisation' && formComponent.organisation.client != null && noClient">
                    <div class="row">
                        <div class="col-lg-12 noCustomerToShow">
                            <span>{{titles.noCustomersToShowPleaseAddANew}}</span>
                        </div>
                    </div>
                </div>
                <div :class="{'disabledInput': formName == 'organisation'}"
                     v-if="formComponent.organisation.client!= null && (formComponent.organisation.client.firstName || formName == 'client')">

                    <div class="px-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <Input :icon="icons.user"
                                       :inputKey="'firstName'"
                                       :name="titles.firstName"
                                       :validate="$v.formComponent.organisation.client.firstName"
                                       @method="getValue"
                                />
                            </div>
                            <div class="col-lg-6">
                                <Input :icon="icons.user"
                                       :inputKey="'lastName'"
                                       :name="titles.lastName"
                                       :validate="$v.formComponent.organisation.client.lastName"
                                       @method="getValue"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="px-4" v-if="$route.path.includes('validateUser') && $route.params.state == 0">
                        <div class="row">
                            <div class="col-lg-6">
                                <Input :icon="icons.password"
                                       :inputKey="'newPassword'"
                                       :name="titles.newpassword"
                                       :type="'password'"
                                       :validate="$v.formComponent.organisation.client.newPassword"
                                       @method="getValue"/>
                            </div>
                            <div class="col-lg-6">
                                <Input :icon="icons.password"
                                       :inputKey="'newRetypedPassword'"
                                       :name="titles.newRetypedPassword"
                                       :type="'password'"
                                       :validate="$v.formComponent.organisation.client.newRetypedPassword"
                                       @method="getValue"/>
                            </div>
                        </div>
                    </div>
                    <div class="px-4">
                        <div class="row">
                            <div :class="{'disabledInput': ($route.path.includes('validateUser') || formComponent.organisation.client.enabled)}"
                                 class="col-lg-6">
                                <Input :disabled="($route.path.includes('validateUser') || formComponent.organisation.client.enabled)"
                                       :icon="icons.email"
                                       :inputKey="'email'"
                                       :name="titles.adresseEmailCommercial"
                                       :validate="$v.formComponent.organisation.client.email"
                                       @method="getValue"
                                />
                                <div class="invalid-feedback"> {{this.emailError}}</div>
                                <div :class="{ 'invalid-feedback-erreur': error == 'UserExist'}"
                                     class="invalid-feedback">
                                    {{titles.emailExist}}
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <DropDownVue :icon="icons.country"
                                             :items="countries"
                                             :label="titles.country"
                                             :validate="$v.formComponent.organisation.client.country.id"
                                             @method="handleChangeDropDown"
                                             inputKey="country"
                                             itemKey="id"
                                             itemValue="name"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="px-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <DropDownVue :icon="icons.currency"
                                             :items="currencies"
                                             :label="titles.currency"
                                             :simpleSelect="true"
                                             :validate="$v.formComponent.organisation.client.currency"
                                             @method="handleChangeDropDown"
                                             inputKey="currency"
                                             itemKey="code"
                                             itemValue="name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <DropDownVue :icon="icons.language"
                                             :items="languages"
                                             :label="titles.language"
                                             :validate="$v.formComponent.organisation.client.language.id"
                                             @method="handleChangeDropDown"
                                             inputKey="language"
                                             itemKey="id"
                                             itemValue="nativeName"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="px-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <VuePhoneNumberInput :border-radius="0"
                                                     :disabled="$route.path.includes('validateUser')"
                                                     :class="{'disabledInput': $route.path.includes('validateUser')}"
                                                     :countries-height="20"
                                                     :default-country-code="countryCode"
                                                     :ignored-countries="['IL']"
                                                     :required="$route.path.includes('validateUser')? true: false"
                                                     :show-code-on-list="true"
                                                     :translations="translation"
                                                     @input="phoneClicked"
                                                     color="#94878B"
                                                     id="phone"
                                                     ref="PhoneNumberInput"
                                                     size="sm"
                                                     v-model="formComponent.organisation.client.phone"
                                />
                                <br>
                                <div :class="{ 'invalid-feedback-erreur': $v.formComponent.organisation.client.phone
             && $v.formComponent.organisation.client.phone.required == false
              && $v.formComponent.organisation.client.phone.$dirty == true
               && $v.formComponent.organisation.client.phone.$error == true && phoneIsValid}"
                                     class="invalid-feedback">
                                    {{titles.fieldIsRequired}}
                                </div>
                                <div :class="{ 'invalid-feedback-erreur': !phoneIsValid}"
                                     class="invalid-feedback">
                                    {{titles.invalidPhoneNumber}}
                                </div>
                            </div>
                            <div class="col-lg-6" style="margin-top: 4%" v-if="formName == 'client'
                                && !formComponent.organisation.client.voucher
                                && !$route.path.includes('validateUser')">
                                <CheckBox :name="titles.generatePromoCode" :validate="voucher" @method="getValue"/>
                            </div>
                        </div>
                    </div>
                    <div class="px-4"
                         v-if="formName == 'client' && formComponent.organisation.client.voucher && tableList.dateDiff(formComponent.organisation.client.voucher.expiresAt) > 0">
                        <div class="row voucher">
                            <table class="blue-border">
                                <tr>
                                    <td class="amount">
                                        {{formComponent.organisation.client.voucher.defaultVoucher.amount}}%
                                    </td>
                                    <td class="promo">
                                        <span id="promo-date">-{{ tableList.dateDiff(formComponent.organisation.client.voucher.expiresAt)
                                        }} jrs
                                    </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="code">Code :</td>
                                    <td class="code-voucher">{{formComponent.organisation.client.voucher.code}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div>

                <div class="px-4 text-right" v-if="!$route.path.includes('organisation/update')">
                    <button
                            :disabled="isLoading || noClient"
                            @click="onSubmit"
                            class="btn btn-standard-gradient px-5"
                            type="button"
                    >
                        <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                        {{name_btn}}
                    </button>
                    <modal-success
                            :title="titles.updateClientMessage"
                            @messageFromModal="closeModal"
                            id="success-edit-client"
                    />
                    <modal-success
                            :title="titles.successProfilMessage"
                            @messageFromModal="getMessageFromModal"
                            id="success-profile"

                    />
                    <modal-password
                            :title="titles.pleaseTapYourPassword"
                            @messageFromModalPassword="getMessageFromModalPassword"
                            id="tap-password"
                    />
                    <modal-error
                            :title="titles.cannotAddOperationMessage"
                            id="cannot-add-operation"
                    />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import ModalPassword from '../../common/modal-password';
    import ModalSuccess from '../../common/modal-success';
    import {
        editClient,
        getAllClients,
        updateUser,
        verifEmail
    } from '../services/user.service';
    import {getPackCountryDomain} from '../services/packCountryDomain.service';
    import {getAllLanguages} from '../services/language.service';
    import DropDownVue from '../../common/DropDownVue';
    import {
        email,
        helpers,
        minLength,
        required,
        sameAs
    } from 'vuelidate/lib/validators';
    import {getAllCountriesJson} from '../services/country.service';
    import {titles} from '../../../utils/general/titles';
    import Input from '@/components/common/Input.vue';
    import CheckBox from '@/components/common/CheckBox.vue';
    import {client} from '../models/client';
    import {icons} from '../../../utils/general/icons';
    import timezones from '@/assets/data/timezones.json';
    import currencies from '@/assets/data/currencies.json';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import {tableList} from '../../../utils/general/tableList';
    import {country} from '../models/country';
    import {language} from '../models/language';
    import ModalError from '../../common/modal-error';
    import {getCountryInformation} from '../services/currenciesTimezones.service';
    import {DEFAULT_COUNTRY_CODE} from '../../../config/config';
    import Loading from '../../common/Loading';
    import {errorMixin} from '../../../utils/errorMixin';
    import {filterMixin} from '../../../utils/filterMixin';

    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    export default {
        name: 'ClientInfo',
        components: {
            Loading,
            VuePhoneNumberInput,
            Input,
            DropDownVue,
            CheckBox,
            ModalSuccess,
            ModalPassword,
            ModalError
        },
        props: {
            form: Object,
            tabs: Array,
            codePromo: Boolean,
            emailError: String
        },
        data() {
            return {
                titles,
                icons,
                timezones,
                tableList,
                filterList: [],
                filterQuery: '',
                sort: '',
                translation: {
                    countrySelectorLabel: '',
                    countrySelectorError: '',
                    phoneNumberLabel: titles.phone,
                    example: titles.examplePhoneNumber
                },
                isLoading: false,
                isEditable: false,
                errorMsg: '',
                formComponent: this.$route.path.includes('client/update') ? {organisation: {client: this.form}} : this.form,
                voucher: this.codePromo ? this.codePromo : false,
                clients: [],
                languages: [],
                name_btn: this.$route.path.includes('add') || this.$route.path.includes('validateUser') ? titles.next :
                    (this.$route.path.includes('profile') || this.$route.path.includes('update')) ? titles.update : titles.add,
                countries: null,
                currencies: [],
                phone: null,
                formName: this.$route.path.includes('organisation') ? 'organisation' :
                    this.$route.path.includes('profile') ? 'profile' :
                        this.$route.path.includes('validateUser') ? 'validateUser' : 'client',
                packCountryDomain: null,
                msgModal: null,
                msgModalSucess: null,
                phoneIsValid: true,
                error: this.emailError,
                disabledButton: false,
                noClient: false,
                countryCode: ''
            };
        },
        created() {
            getAllCountriesJson().then(response => {
                this.countries = response.data.map(item => country(item));
                this.countries = this.countries.filter(item => item.code != DEFAULT_COUNTRY_CODE);
            });
            if (this.$route.path.includes('add')) {
                this.$cookies.remove('clientItemIsEditable');
                this.$cookies.remove('clientItem');
            }
            if (this.$route.params.clientItem) {
                this.$cookies.set('clientItemIsEditable', this.$route.params.isEditable);
                this.$cookies.set('clientItem', this.$route.params.clientItem);
            }
            if (this.$cookies.isKey('clientItemIsEditable')) {
                this.isEditable = this.$cookies.get('clientItemIsEditable');
                this.title = titles.clientDetailExpression;
                this.name_btn = titles.update;
            }
            this.disabledButton = true;
            if (this.formName != 'validateUser') {
                this.getClientsList();
            }
            this.getLanguagesList();
            this.getCurrenciesList();
            this.$emit('formValidate', this.$v);
            this.countryCodeValue();
            localStorage.setItem("domain", JSON.stringify(this.formComponent.packCountryDomain.domain));
            localStorage.setItem("typePack", JSON.stringify(this.formComponent.packCountryDomain.typePack));

        },
        updated() {
            if (this.emailError != null) {
                this.error = this.emailError;
            }
            if ((this.formName == 'client' || this.formName == 'profile') && this.formComponent.organisation.client.country) {
                this.formComponent.organisation.client.phoneNumberCode = this.$refs.PhoneNumberInput.countryCode;
            }
        },
        mixins: [filterMixin, errorMixin],
        methods: {
            countryCodeValue() {
                this.countryCode = this.formComponent.organisation.client.phoneNumberCode;
                if (this.formComponent.organisation.client.country) {
                    this.countryCode = this.formComponent.organisation.client.country.code;
                }
            },
            phoneClicked() {
                if (this.$refs.PhoneNumberInput.isValid != true && this.formComponent.organisation.client.phone != null) {
                    this.phoneIsValid = false;
                } else {
                    this.phoneIsValid = true;
                }
                if (!this.$refs.PhoneNumberInput.hasEmptyPhone) {
                    this.$v.formComponent.organisation.client.phone.$touch();
                }
                this.$emit('phoneClick', this.phoneIsValid);
            },
            handleChangeDropDown(val, inputKey) {
                if (inputKey == 'client') {
                    this.formComponent.organisation[inputKey] = val;
                    if(val != null) {
                        this.countryCodeValue();
                    }
                } else if (inputKey == 'country') {
                    this.formComponent.organisation.client[inputKey] = val;
                    if(val != null){
                        this.countryCodeValue();
                        getCountryInformation(this.formComponent.organisation.client.country.code).then(response => {
                            for (const currency in currencies) {
                                if (currency == response.data.currencies[0].code) {
                                    this.formComponent.organisation.client.currency = currency;
                                    this.$v.formComponent.organisation.client.currency.$touch();
                                }
                            }
                        });
                    }else{
                        this.formComponent.organisation.client.currency = null;
                        this.formComponent.organisation.client.phoneNumberCode = 'FR';
                        this.countryCode= 'FR';
                    }
                } else {
                    this.formComponent.organisation.client[inputKey] = val;
                }
                if (!this.$route.path.includes('client/update') && this.formName != 'profile' && val != null) {
                    this.updatePacks(inputKey);
                }
            },
            getValue(inputKey, val) {
                this.error = null;
                if (inputKey == undefined) {
                    this.voucher = val;
                } else {
                    this.formComponent.organisation.client[inputKey] = val;
                }
            },
            verifEmail(mail) {
                verifEmail(mail).then(
                    response => {
                        if (response.data == 'Not Exist') {
                            this.nextTab();
                        }
                    }, error => {
                        const err = error.response;
                        this.error = err.data.error;
                        this.isLoading = false;
                    });
            },
            onSubmit() {
                //this.$v.$touch();
                if (this.$v.$invalid || !this.phoneIsValid) {
                    return;
                }
                if (this.formName == 'validateUser') {
                    this.$emit('next', this.formComponent, 'step1');
                }
                if (this.formName == 'client' && !this.$route.path.includes('client/update')) {
                    this.verifEmail(this.formComponent.organisation.client.email);
                } else if (this.formName == 'organisation') {
                    this.nextTab();
                } else if (this.formName == 'profile') {
                    if (this.formComponent.organisation.client.email != this.$cookies.get('user').email) {
                        this.$bvModal.show('tap-password');
                    } else {
                        this.updateProfile();
                    }
                }
                if (this.$cookies.isKey('clientItemIsEditable')) {
                    const localClient = client(this.formComponent.organisation.client);
                    localClient.country = localClient.country.id;
                    localClient.language = localClient.language.id;
                    delete localClient.id;
                    editClient(localClient, this.voucher, this.form.id).then(
                        response => {
                            this.formComponent.organisation.client.id = response.data.id;
                            this.$bvModal.show('success-edit-client');
                            this.isLoading = false;
                            return response;

                        },
                        error => {
                            if (error.response.data.message == 'Form Invalid') {
                                this.$bvModal.show('cannot-add-operation');
                                this.isLoading = false;
                            } else {
                                const err = error.response;
                                this.error = err.data.error;
                                this.isLoading = false;
                            }
                        });
                }
                this.error = null;
                this.errorMsg = null;
                this.isLoading = true;

            },
            getMessageFromModal(modal) {
                this.msgModalSucess = modal;
                if (typeof this.msgModal == 'string' && this.msgModalSucess == true) {
                    this.$router.push({name: 'login'});
                }
            },
            getMessageFromModalPassword(msgModal) {
                this.msgModal = msgModal;
                if (this.msgModal != null && typeof this.msgModal == 'string') {
                    this.updateProfile();
                } else if (typeof this.msgModal == 'boolean') {
                    this.isLoading = false;
                }
            },
            updateProfile() {
                updateUser(this.formComponent.organisation.client, this.$store.getters.user.id).then(
                    response => {
                        if (response.data === 'UserExist') {
                            this.error = response.data;
                            this.isLoading = false;
                            return null;
                        }
                        if (this.formComponent.organisation.client.firstName != this.$cookies.get('user').firstName) {
                            this.$store.getters.user.firstName = this.formComponent.organisation.client.firstName;
                        }
                        this.$bvModal.show('success-profile');
                        this.isLoading = false;
                        return response;
                    },
                    error => {
                        this.showError(error);
                    }
                );
            },
            nextTab() {
                this.$emit('nextTab', {
                    name: 'Organisation',
                    component: 'OrganisationInfo'
                }, this.voucher);
            },
            getClientsList() {
                this.orderQueryGenerator('created', true);
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'enabled',
                    1,
                    null
                );
                getAllClients(1000, 1, this.sort, this.filterQuery).then(response => {
                    this.clients = response.data['hydra:member'].map(actualClientInfo => {
                        this.disabledButton = false;
                        return client(actualClientInfo);
                    });
                    if (this.clients.length === 0 && this.formName === 'organisation') {
                        this.disabledButton = false;
                        this.noClient = true;
                        this.$emit('noClient', this.noClient);
                    }
                });

            },
            getLanguagesList() {
                if (this.languages.length === 0) {
                    getAllLanguages().then(response => {
                        this.languages = response.data.map(localLanguage => language(localLanguage));
                    });
                }
            },
            getCurrenciesList() {
                if (this.currencies.length === 0) {
                    this.currencies = Object.values(currencies).map(currency => {
                        return {'code': currency.code, 'name': currency.code + ' - ' + currency.name};
                    });
                }
            },
            getPackCountryDomain() {
                getPackCountryDomain(this.formComponent.packCountryDomain.domain.name,
                    this.formComponent.organisation.client.country.code, 'BackOffice', false).then(response => {
                    this.packCountryDomain = Object.values(response.data['hydra:member']);
                    this.$emit('getPackCountryDomain', this.packCountryDomain);
                });
            },
            updatePacks(inputKey) {
                if (((inputKey === 'country' || inputKey === 'client')
                    && this.formComponent.packCountryDomain.domain.id != null)) {
                    this.getPackCountryDomain();

                }
            },
            closeModal() {
                this.$cookies.remove('clientItemIsEditable');
                if(this.$cookies.isKey('editClientPage')){
                    this.$router.push({name: 'listCommercial'});
                }else{
                    this.$router.push({name: 'network'});


                }
            }
        },
        validations() {
            if (this.formName === 'organisation') {
                return {
                    formComponent: {
                        organisation: {
                            client: {
                                required,
                                id: {required},
                                firstName: {},
                                lastName: {},
                                country: {
                                    id: {}
                                },
                                currency: {},
                                language: {
                                    id: {}
                                },
                                email: {},
                                phone: {}
                            }
                        }
                    }
                };
            } else if (this.formName === 'validateUser' && this.$route.params.state == 0) {
                return {
                    formComponent: {
                        organisation: {
                            client: {
                                required,
                                firstName: {required},
                                lastName: {required},
                                newPassword: {required, mustBeValidPassword, minLength: minLength(6)},
                                newRetypedPassword: {required, sameAsPassword: sameAs('newPassword')},
                                country: {
                                    required,
                                    id: {required}
                                },
                                currency: {required},
                                phone: {required},
                                language: {
                                    required,
                                    id: {required}
                                },
                                email: {required, email}
                            }
                        }
                    }
                };
            } else if (this.formName === 'validateUser' && this.$route.params.state == 1) {
                return {
                    formComponent: {
                        organisation: {
                            client: {
                                required,
                                firstName: {required},
                                lastName: {required},
                                country: {
                                    required,
                                    id: {required}
                                },
                                currency: {required},
                                phone: {required},
                                language: {
                                    required,
                                    id: {required}
                                },
                                email: {required, email}
                            }
                        }
                    }
                };
            } else {
                return {
                    formComponent: {
                        organisation: {
                            client: {
                                required,
                                firstName: {required},
                                lastName: {required},
                                country: {
                                    id: {}
                                },
                                currency: {},
                                language: {
                                    id: {}
                                },
                                email: {required, email},
                                phone: {}
                            }
                        }
                    }
                };
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/vue-phone-number-input.css';
    @import '../../../assets/style/css/base.css';


</style>
